import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Registering required components for Chart.js 4.x
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function VitalHandler({
  vitalName,
  vitalLabelsArray,
  vitalDataArray,
}) {
  // State to store the chart data
  const [chartData, setChartData] = useState({
    labels: vitalLabelsArray,
    datasets: [
      {
        label: vitalName,
        data: vitalDataArray,
        // Set the color of the curve (line)
        borderColor: 'rgba(75, 192, 192, 0.5)', // Semi-transparent curve line
        // Set the color of the area under the curve (fill area)
        backgroundColor: 'rgba(75, 192, 192, 0.2)', // Semi-transparent fill color for the area under the curve
        pointBackgroundColor: 'rgba(75, 192, 192, 0.5)', // Semi-transparent points (optional)
        borderWidth: 2, // Adjust border width for better visibility
        tension: 0.4, // This creates a curved line
        fill: true, // This enables the filling of the area under the curve
      },
    ],
  });

  // Chart options (you can customize these as needed)
  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        mode: 'nearest',
      },
    },
  };

  // UseEffect to update chart data (optional, in case the data is dynamic)
  useEffect(() => {
    setChartData({
      labels: vitalLabelsArray,
      datasets: [
        {
          label: vitalName,
          data: vitalDataArray,
          borderColor: 'rgba(75, 192, 192, 0.5)', // Semi-transparent curve line
          backgroundColor: 'rgba(75, 192, 192, 0.2)', // Semi-transparent fill color for the area under the curve
          pointBackgroundColor: 'rgba(75, 192, 192, 0.5)', // Semi-transparent points
          borderWidth: 2,
          tension: 0.4, // Add curvature
          fill: true, // Enable the fill beneath the curve
        },
      ],
    });
  }, [vitalName, vitalLabelsArray, vitalDataArray]); // Dependencies to re-render the chart when data changes

  return (
    <div className="col-md-6">
      <div className="grid">
        <div className="grid-body">
          <h2 className="grid-title">{vitalName}</h2>
          <div className="item-wrapper">
            {/* Render Line chart using react-chartjs-2 */}
            <Line data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
}
